<div class="breadcrumb-bar" data-aos="fade-in" data-aos-duration="800" *ngIf="app?.isPlatformBrowserVar">
    <div class="container-fluid">
        <div class="row">

            <div class="col-3 d-flex align-items-center">
                <nav aria-label="breadcrumb" class="page-breadcrumb">
                    <ol class="breadcrumb nav-family-font">
                        <mat-icon class="home-icon" aria-hidden="false" aria-label="Example home icon">home</mat-icon>
                        <li class="breadcrumb-item"><a [routerLink]="'/' + this?.app?.languageCode + '/home'">{{
                                'navigationBar.Home' | translate }}</a>
                        </li>
                        <i *ngIf="this.app?.getUserLanguage() == 'en'" class="fa fa-angle-right nav-font"></i>
                        <i *ngIf="this.app?.getUserLanguage() == 'ar'" class="fa fa-angle-left nav-font"></i>
                        <li class="breadcrumb-item active" aria-current="page">{{ 'social.myCommAct' | translate }}
                        </li>
                    </ol>
                </nav>
            </div>

            <!-- search field -->
            <div class="col-6 d-flex justify-content-center">

                <!-- <mat-form-field [dir]="this?.app?.getUserDire()" class="searchField" appearance="outline" fxFlex="auto">
                    <input [formControl]="searchInput" (keyup.enter)="getPosts()"
                        [placeholder]=" 'social.search' | translate " autocomplete="off" type="text" matInput>
                    <mat-icon class="pointer" (click)="getPosts()" matSuffix>search</mat-icon>
                </mat-form-field> -->

                <!-- =================================== -->

                <mat-form-field [dir]="this?.app?.getUserDire()" class="searchField" appearance="outline" fxFlex="auto">

                    <input type="text" matInput [formControl]="searchInput" (keyup.enter)="getPosts()"
                        [matAutocomplete]="auto" [placeholder]=" 'social.search' | translate ">
                    <!-- autoActiveFirstOption -->
                    <!-- (optionSelected)='getPosts()' -->
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option class="greyColor" *ngIf="searchOptions?.length == 0">{{ 'social.noRecentSearch' |
                            translate }}</mat-option>
                        <mat-option *ngFor="let option of searchOptions ; let i = index" [value]="option">

                            <div class="d-flex justify-content-between">
                                <span>
                                    {{option}}
                                </span>

                                <div class="d-flex align-items-center">
                                    <mat-icon (click)="deleteOptionFromSearchHistory(i)" class="mainColor"
                                        matSuffix>close</mat-icon>
                                </div>

                            </div>


                        </mat-option>
                    </mat-autocomplete>

                    <mat-icon class="pointer" (click)="getPosts()" matSuffix>search</mat-icon>
                </mat-form-field>

            </div>
            <!-- search field -->

            <!-- notifications -->
            <div class="col-3 d-flex justify-content-center align-items-center">
                <!-- id="notifications" data-bs-toggle="dropdown" -->
                <div (click)="notifications()" class="dotCir">
                    <mat-icon class="mainColor"
                        [ngClass]="notificationsTap ? 'text-success' : 'mainColor'">notifications</mat-icon>
                </div>
            </div>
            <!-- notifications -->

        </div>
    </div>
</div>

<div class="content" *ngIf="app?.isPlatformBrowserVar">
    <div class="container-fluid">
        <div class="row">

            <!-- sideMenu -->
            <div class="col-xl-3 col-lg-3 col-md-0 col-sm-0 adsCol">
                <app-sidemenu *ngIf="this.app.isDoctor"></app-sidemenu>
                <app-sidemenuPatient *ngIf="this.app.isPatient"></app-sidemenuPatient>
                <app-side-menu-contributor *ngIf="this.app.isContributor"></app-side-menu-contributor>
                <app-social-manager-side-bar *ngIf="this.app.IsSocialMediaManager"></app-social-manager-side-bar>
                <app-side-bar-not-logged class="h-100" *ngIf="!this.app.getUserData()"></app-side-bar-not-logged>
            </div>
            <!-- sideMenu -->

            <!-- main -->
            <div class="col-xl-6 col-lg-6 col-md-9 col-sm-12">
                <div class="d-flex justify-content-center">
                    <div class="card feedsWidth m-100vr">
                        <div class="p-3">

                            <!-- stories -->
                            <div class="mb-3" data-aos="fade-up" data-aos-duration="800" *ngIf="stories?.length > 0">
                                <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfigureForDoctor"
                                    [ngClass]="this.app?.getUserLanguage() == 'en' ? 'EnCar' : 'ArCar'">

                                    <!-- <div>
                                        <div class="storyYou mx-1 pos-rel pointer">
                                            <img class="storyImgYou"
                                                [src]="app?.getUserImage(app?.getUserData()?.picture)">

                                            <div class="d-flex pointer youCir">
                                                <span class="dotCirIcon"><mat-icon
                                                        class="postIcons">add</mat-icon></span>
                                            </div>
                                        </div>
                                        <div class="text-center XYcenter">
                                            <p *ngIf="stories?.length != 0" class="creName mb-0 mt-10">You</p>
                                        </div>
                                    </div> -->

                                    <div (click)="openStory(i)" ngxSlickItem
                                        *ngFor="let item of stories ; let i = index">

                                        <div class="story mx-1 pointer"
                                            [ngClass]="item.iViewdStory == false ? 'storyNotViewed' : ''">
                                            <!-- <img loading="lazy" class="storyImg"
                                                [src]="app?.getUserImage(item?.creatorPicture)"> -->

                                            <app-img-loader [className]="'storyImg'"
                                                [src]="item?.creatorPicture"></app-img-loader>

                                        </div>
                                        <div class="text-center XYcenter">
                                            <p class="creName my-2">{{item?.creatorName | splitStringToArEn}}</p>
                                        </div>

                                    </div>

                                </ngx-slick-carousel>
                            </div>
                            <!-- stories -->

                            <!-- post -->
                            <div *ngIf="app?.isDoctor || app?.isContributor" (click)="postPopUp()"
                                class="px-4 d-flex justify-content-between pointer" data-aos="fade-up"
                                data-aos-duration="800">

                                <img loading="lazy" class="border-less"
                                    [src]="app.getUserImage(app?.getUserData()?.picture)" alt="User Image">

                                <mat-form-field disabled class="w-100 px-2 feedField h65 "
                                    [dir]="this?.app?.getUserDire()" appearance="outline">
                                    <!-- <mat-label>{{ 'social.search' | translate }}</mat-label> -->
                                    <input disabled class="" [value]="'social.whatsYourMind' | translate" type="text"
                                        matInput>
                                    <!-- [placeholder]=" 'social.whatsYourMind' | translate " -->
                                </mat-form-field>
                            </div>
                            <div *ngIf="app?.isDoctor || app?.isContributor" (click)="postPopUp()"
                                class="p-4 d-flex justify-content-between pointer" data-aos="fade-up"
                                data-aos-duration="800">
                                <div class="d-flex">
                                    <span class="dotCirIcon"><mat-icon class="postIcons">add_a_photo</mat-icon></span>
                                    <p class="postP mx-2">{{ 'social.video' | translate }}</p>
                                </div>

                                <div class="d-flex">
                                    <span class="dotCirIcon"><mat-icon class="postIcons">image</mat-icon></span>
                                    <p class="postP mx-2">{{ 'social.photo' | translate }}</p>
                                </div>

                                <div class="d-flex">
                                    <span class="dotCirIcon"><mat-icon class="postIcons">link</mat-icon></span>
                                    <p class="postP mx-2">{{ 'social.Link' | translate }}</p>
                                </div>


                            </div>
                            <!-- post -->

                            <!-- switchButtons -->
                            <div class="px-2" *ngIf="switchListInterest" data-aos="fade-up" data-aos-duration="800">
                                <div class="row mb-3">
                                    <div class="px-3">
                                        <button (click)="switchOnClick('all')"
                                            [class.selectedN]="selectedButton == 'all'"
                                            class="btn sharedBtn mx-1 mb-3 px-3  justify-content-center align-items-center">
                                            <p class="d-flex justify-content-center align-items-center m-0">
                                                <span class="mFont">{{ 'social.all' | translate }}</span>
                                            </p>
                                        </button>
                                        <button (click)="switchOnClick('forYou')"
                                            [class.selectedN]="selectedButton == 'forYou'"
                                            class="btn sharedBtn mx-1 mb-3 px-3  justify-content-center align-items-center">
                                            <p class="d-flex justify-content-center align-items-center m-0">
                                                <span class="mFont">{{ 'social.forYou' | translate }}</span>
                                            </p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- switchButtons -->

                            <!-- feeds -->
                            <div class="px-3 mb-5" *ngFor="let post of Posts;let i = index" data-aos="fade-up"
                                data-aos-duration="800">
                                <!-- Post Header -->
                                <div class="d-flex justify-content-between">

                                    <div class="d-flex">

                                        <!-- <img loading="lazy" class="border-less posterImg creatorPost"
                                            [src]="app.getUserImage(post?.creatorPicture)" alt="User Image"> -->

                                        <app-img-loader class="pointer" (click)="routeToDocProfile(post)"
                                            [className]="'creatorPost'" [src]="post?.creatorPicture"></app-img-loader>

                                        <div class="mx-2 d-flex align-items-start">
                                            <div>
                                                <p class="m-0 posterName pointer" (click)="routeToDocProfile(post)">
                                                    {{post?.creatorName | splitStringToArEn}}</p>
                                                <p class="m-0 posterSpech">{{post?.creatorSpeciality |
                                                    splitStringToArEn}}</p>
                                                <p class="m-0 posterSpech">{{post?.createdAt | relativeTime:
                                                    app?.languageCode}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-start">
                                        <!-- <mat-icon *ngIf="post?.isPromoted" class="text-warning mx-2">new_releases</mat-icon> -->
                                        <p class="sponsP mx-2 m-0" *ngIf="post?.isPromoted">{{ 'social.promoted' |
                                            translate }}</p>
                                        <mat-icon *ngIf="this.app.getUserData()"
                                            (click)="editPostPopUp(post?.postId,post?.isMyPost)"
                                            class="threeDotsColor pointer">more_vert</mat-icon>
                                    </div>

                                </div>
                                <!-- Post Header -->

                                <!-- Post Content -->
                                <div class="my-2">

                                    <p class="postContentP my-2" [ngClass]="post?.textDirection == 'ltr' ? 'ltr1' : 'rtl1'">
                                        <span *ngIf="post?.postText?.length < 400">{{post?.postText}}</span>
                                        <span *ngIf="post?.postText?.length >= 400">
                                            <span *ngIf="!post?.postTextLengthMoreThan400 || post?.postTextLengthMoreThan400 == false">
                                                {{post?.postText.slice(0, 400)}}<span class="text-primary mx-2 pointer" (click)="this?.Posts[i].postTextLengthMoreThan400 = true">{{ 'social.showMore2' | translate }}</span>
                                            </span>
                                            <span *ngIf="post?.postTextLengthMoreThan400 == true">{{post?.postText}}</span>
                                        </span>
                                    </p>

                                    <div *ngIf="post?.postMedia">

                                        <div *ngIf="post?.postMedia[0]?.mediaType == 1">
                                            <div *ngIf="post?.postMedia?.length == 1">
                                                <!-- <img class="postImg" [src]="post?.postMedia[0]?.mediaFilePath" alt=""> -->
                                                <app-img-loader (click)="postDetailsPopUp(post?.postId,null)"
                                                    class="XYcenter" [className]="'postImg'"
                                                    [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                                            </div>

                                            <div *ngIf="post?.postMedia?.length == 2">
                                                <div class="row">
                                                    <div *ngFor="let media of post?.postMedia; let i = index"
                                                        class="col-6">
                                                        <!-- <img class="postImg" [src]="media?.mediaFilePath" alt=""> -->
                                                        <app-img-loader [className]="'posImg2'"
                                                            (click)="postDetailsPopUp(post?.postId,i)" class="XYcenter"
                                                            [src]="media?.mediaFilePath"></app-img-loader>
                                                    </div>
                                                </div>
                                            </div>

                                            <div *ngIf="post?.postMedia?.length == 3">
                                                <div class="row mb-2">
                                                    <app-img-loader (click)="postDetailsPopUp(post?.postId,null)"
                                                        class="XYcenter" [className]="'postImg'"
                                                        [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <app-img-loader (click)="postDetailsPopUp(post?.postId,1)"
                                                            class="XYcenter" [className]="'posImg3'"
                                                            [src]="post?.postMedia[1]?.mediaFilePath"></app-img-loader>
                                                    </div>
                                                    <div class="col-6">
                                                        <app-img-loader (click)="postDetailsPopUp(post?.postId,2)"
                                                            class="XYcenter" [className]="'posImg3'"
                                                            [src]="post?.postMedia[2]?.mediaFilePath"></app-img-loader>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="post?.postMedia?.length > 3">
                                                <div class="row mb-2">
                                                    <!-- <img class="postImg" [src]="post?.postMedia[0]?.mediaFilePath" alt=""> -->
                                                    <app-img-loader (click)="postDetailsPopUp(post?.postId,null)"
                                                        class="XYcenter" [className]="'postImg'"
                                                        [src]="post?.postMedia[0]?.mediaFilePath"></app-img-loader>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <app-img-loader (click)="postDetailsPopUp(post?.postId,1)"
                                                            class="XYcenter" [className]="'postSubImg'"
                                                            [src]="post?.postMedia[1]?.mediaFilePath"></app-img-loader>
                                                    </div>
                                                    <div class="col-4">
                                                        <app-img-loader (click)="postDetailsPopUp(post?.postId,2)"
                                                            class="XYcenter" [className]="'postSubImg'"
                                                            [src]="post?.postMedia[2]?.mediaFilePath"></app-img-loader>
                                                    </div>
                                                    <div class="col-4" (click)="postDetailsPopUp(post?.postId,null)">
                                                        <div class="h-100 w-100 seeMoreBox">
                                                            <p class="mb-0 moreThan3P">+{{post?.postMedia?.length - 3}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="post?.postMedia[0]?.mediaType == 2">
                                            <div>
                                                <video width="100%" class="videoCom" controls>
                                                    <source [src]="app.getImageFile(post?.postMedia[0]?.mediaFilePath)"
                                                        type="video/mp4">
                                                </video>
                                            </div>
                                        </div>
                                        <div *ngIf="post?.postMedia[0]?.mediaType == 3">
                                            <div class="card pointer"
                                                (click)="urlClicked(post?.postMedia[0]?.mediaFilePath)">

                                                <img loading="lazy" [src]="post?.postMedia[0]?.urlImage">


                                                <span class="p-3 UrlDesc"> {{post?.postMedia[0]?.urlDescription}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Post Content -->

                                <!-- post footer -->
                                <div class="justify-content-between d-flex">
                                    <div>
                                        <div class="inline-block">
                                            <div class="d-flex pointer">
                                                <mat-icon class="favColor like-icon"
                                                    [ngClass]="{'liked': post?.iLikedPost}"
                                                    (click)="likeDislikePost(post?.postId,post?.iLikedPost,i)">{{post?.iLikedPost
                                                    ?
                                                    'favorite' :'favorite_outlined'}}</mat-icon>
                                                <p class="m-0 favNumbers  mx-1 d-flex align-items-center"
                                                    (click)="likesPopUp(post?.postId,post?.likesCount,'post')">
                                                    {{post?.likesCount| likeCount}}</p>
                                            </div>
                                        </div>

                                        <div class="inline-block">
                                            <div class="d-flex pointer mx-2"
                                                (click)="postDetailsPopUp(post?.postId,null)">
                                                <mat-icon class="commentsColor">chat_bubble_outlined</mat-icon>
                                                <p class="m-0 favNumbers mx-1 d-flex align-items-center">
                                                    {{post?.commentsCount}}</p>
                                            </div>
                                        </div>
                                        <!-- *ngIf="post?.isMyPost == true" -->
                                        <div class="inline-block">
                                            <div class="d-flex pointer" (click)="chartPopUp(post?.postId,post?.isMyPost)">
                                                <mat-icon class="barColor">analytics_outlined</mat-icon>
                                                <p class="m-0 favNumbers mx-1 d-flex align-items-center">
                                                    {{post?.reachCount}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="d-flex pointer" (click)="arrowPopUp(post?.postId)">
                                            <!-- [ngClass]="this.app?.getUserLanguage() == 'en' ? 'dotCirArrowEn' : 'dotCirArrowAr'" -->
                                            <span class="dotCirIconArrow"><mat-icon
                                                    class="arrowIcons">link</mat-icon></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- post footer -->
                            </div>
                            <!-- feeds -->

                        </div>
                    </div>
                </div>
            </div>
            <!-- main -->

            <!-- advertisments -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-0 pos-rel" data-aos="fade-up" data-aos-duration="800">
                <div class="card">
                    <div class="d-flex justify-content-center">
                        <p class="adText my-4">{{ 'social.Advs' | translate }}</p>
                    </div>
                    <hr class="m-0 greyColor">

                    <div *ngFor="let ad of Ads" (click)="openUrlAd(ad?.urlToOpen)">
                        <div class="p-2">
                            <app-img-loader [className]="'adImg'" [src]="ad?.image"></app-img-loader>
                            <p>{{ad?.adText}}</p>
                        </div>
                        <hr>
                    </div>

                    <div *ngIf="Ads?.length == 0" class="d-flex justify-content-center">
                        <p class="adText my-4">{{ 'social.noAds' | translate }}</p>
                    </div>

                </div>
                <div class="notiBox w-100" *ngIf="notificationsTap" [@fadeUpAnimation]>

                    <div class="XYcenter p-4 shadow-sm">

                        <p class="netP m-0">{{ 'social.notifications' | translate }}</p>

                    </div>

                    <hr class="greyColor m-0">

                    <!-- dropDownList -->
                    <ul class="notiList p-3 shadow-sm bg-body" *ngIf="notificationsRes?.length > 0">
                        <div class="overFlowNot">
                            <div *ngFor="let notification of notificationsRes">
                                <li>
                                    <div class="d-flex my-3 pointer"
                                        (click)="postDetailsPopUp(notification?.postId,null)">

                                        <!-- <img class="border-less" [src]="notification?.userPicture"> -->

                                        <app-img-loader [className]="'notificationIcon'"
                                            [src]="notification?.userPicture"></app-img-loader>

                                        <div class="mx-2 d-flex align-items-start">
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <p class="m-0">
                                                        <!-- <span class="notName">{{notification?.userFullName}}</span> -->
                                                        <span class="notInfo">{{app.languageCode ==
                                                            'en'?notification?.englishNotification :
                                                            notification?.arabicNotification}}</span>
                                                    </p>
                                                    <p class="m-0 notTime">
                                                        {{getTimeDifferenceString(notification?.createdAt)}}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </li>

                                <li>
                                    <hr class="my-1 greyColor">
                                </li>
                            </div>
                        </div>
                    </ul>

                    <div *ngIf="notificationsRes?.length == 0" class="XYcenter p-4 shadow-sm">
                        <p class="netP m-0">{{ 'social.NoNotifications' | translate }}</p>
                    </div>
                    <!-- dropDownList -->
                </div>
            </div>
            <!-- advertisments -->

        </div>
    </div>
</div>

<div *ngIf="app?.isPlatformServerVar"
    style="display: none !important;visibility:hidden !important;opacity: 0 !important;">
    <div *ngFor="let post of PostsForSSR">
        <a [routerLink]=" '/' + app?.languageCode +'/Tebgram/post/' + post?.postId"></a>
        <h2> {{ post?.creatorName }}</h2>
        <h4> {{ post?.creatorSpeciality }}</h4>
        <p> {{ post?.createdAt }}</p>
        <h2> {{ post?.postText }}</h2>
    </div>

    <div *ngFor="let ad of Ads">
        <h2> {{ad?.adText}}</h2>
        <h2> {{ad?.adDescription}}</h2>
        <h2> {{ad?.urlToOpen}}</h2>
    </div>
</div>